import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';

import { FeatureCtaContainer } from 'containers/common/app/feature-cta-container';
import { FooterContainer } from 'containers/common/app/footer-container';
import { HeaderContainer } from 'containers/common/app/header-container';
import { FaqContainer } from 'containers/common/components/faq/faq-container';
import { PageContainer } from 'containers/page/page-container';

import { ComplimentsBlockFourContainer } from './compliments-block-four-container';
import { ComplimentsBlockOneContainer } from './compliments-block-one-container';
import { ComplimentsBlockThreeContainer } from './compliments-block-three-container';
import { ComplimentsBlockTwoContainer } from './compliments-block-two-container';
import { ComplimentsHeroBlockContainer } from './compliments-hero-block-container';

const faqContent = () => [
    {
        question: features.compliments.lxComplimentsFaqQuestionOneTitle,
        answer: features.compliments.lxComplimentsFaqQuestionOneAnswer,
    },
    {
        question: features.compliments.lxComplimentsFaqQuestionTwoTitle,
        answer: features.compliments.lxComplimentsFaqQuestionTwoAnswer,
    },
    {
        question: features.compliments.lxComplimentsFaqQuestionThreeTitle,
        answer: features.compliments.lxComplimentsFaqQuestionThreeAnswer,
    },
];

export const ComplimentsContainer: FunctionComponent = () => {
    return (
        <PageContainer>
            <HeaderContainer />
            <main id="main" tabIndex={-1}>
                <ComplimentsHeroBlockContainer />
                <ComplimentsBlockOneContainer />
                <ComplimentsBlockTwoContainer />
                <ComplimentsBlockThreeContainer />
                <ComplimentsBlockFourContainer />
                <FaqContainer
                    title={features.compliments.lxFeaturesFaqTitle}
                    content={faqContent()}
                />
                <FeatureCtaContainer title={features.compliments.lxComplimentsCta} />
            </main>
            <FooterContainer />
        </PageContainer>
    );
};
